import { render, staticRenderFns } from "./FlipButton.vue?vue&type=template&id=85ea71ec&scoped=true&"
import script from "./FlipButton.vue?vue&type=script&lang=js&"
export * from "./FlipButton.vue?vue&type=script&lang=js&"
import style0 from "./FlipButton.vue?vue&type=style&index=0&id=85ea71ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ea71ec",
  null
  
)

export default component.exports